import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import { Icon, Checkbox } from 'loyal-react'

import {
  Accordion,
  AccordionItem,
  AccordionItemTitle,
  AccordionItemBody
} from 'react-accessible-accordion'

const Filter = ({
  profiles,
  categories,
  places,
  partners,
  filters,
  onOrderChange,
  onFilterChange,
  tags,
  removeTags,
  removeAllTags
}) => {
  const orderColor = type => {
    return {
      fontFamily: filters.order.selected === type ? 'Itau Display Bold' : ''
    }
  }
  const checkSelected = (value, type) => {
    let { profiles, categories, places, partners } = filters

    switch (type) {
      case 'PROFILE': {
        return profiles ? profiles.includes(String(value)) : false
      }
      case 'CATEGORY': {
        return categories ? categories.includes(String(value)) : false
      }
      case 'PLACE': {
        return places ? places.includes(String(value)) : false
      }
      case 'PARTNER': {
        return partners ? partners.includes(String(value)) : false
      }
      default: {
        return false
      }
    }
  }
  const orderChangeAscending = e => {
    onOrderChange({ type: 'ASCENDING' })
  }
  const orderChangeDescending = e => {
    onOrderChange({ type: 'DESCENDING' })
  }
  const orderChangeHigherdiscounts = e => {
    onOrderChange({ type: 'HIGHERDISCOUNTS' })
  }
  const onRemoveAllTags = () => {
    removeAllTags(tags)
  }
  const onRemoveTags = e => {
    removeTags({
      valueFilter: e.target.dataset.valuefilter,
      filterType: e.target.dataset.filtertype
    })
  }
  const inputTags = tags.map(tag => (
    <li className='d-flex'>
      <span className='tag-filtro d-flex align-items-center'>
        {tag.valueFilter}
        <i
          data-valueFilter={tag.valueFilter}
          data-filterType={tag.filterType}
          onClick={onRemoveTags}
          title={`Limpar o filtro ${tag.valueFilter}`}
          className='icon icon_close ml-1'
        />
      </span>
    </li>
  ))
  return (
    <Fragment>
      <div className='row'>
        <div className='border-left border-top border-right border-color-ui-3 w-100 col-12 px-0 border-button-zero'>
          <h2
            className='txt-font-body color-title pb-half txt-beneficios'
            tabIndex='0'
          >
            Benefícios
          </h2>
          <p className='ml-2 mb-2' tabIndex='0'>
            <strong>{this.totalItens} </strong>benefícios encontrados
          </p>
          <div className='tags-filter'>
            <ul className='ml-2 d-flex flex-wrap'>{inputTags}</ul>
          </div>
          <div className='d-flex justify-content-center'>
            <a
              className='limpar-filtros'
              onClick={onRemoveAllTags}
              title='Limpar todos os filtros'
              tabIndex='0'
            >
              Limpar filtros
            </a>
          </div>
        </div>
      </div>
      <Accordion
        className='container-filter row radius border-color-ui-3 radius border-top-zero'
        accordion={false}
      >
        <AccordionItem
          expanded={false}
          className='filter-accordion filtered-accordion border-color-ui-3 col-12 px-0'
        >
          <AccordionItemTitle className='filter-accordion border-color-ui-3 col-12 px-0'>
            <button className='btn-accordion txt-left border-color-ui-3 txt-body-sm'>
              ORDENAR POR
              <Icon iconName='icon_down' />
            </button>
          </AccordionItemTitle>
          <AccordionItemBody className='panel-accordion border-top border-color-ui-3 bg-white px-2 py-2'>
            <div className='filter-price col-12 px-0'>
              <div className='row mx-0 mb-1'>
                <a
                  className='txt-body-sm'
                  value='ASCENDING'
                  onClick={orderChangeAscending}
                  role='button'
                  style={orderColor('ASCENDING')}
                  tabIndex='0'
                >
                  Alfabética (A-Z)
                </a>
              </div>
              <div className='row mx-0 mb-1'>
                <a
                  className='txt-body-sm'
                  value='DESCENDING'
                  onClick={orderChangeDescending}
                  role='button'
                  style={orderColor('DESCENDING')}
                  tabIndex='0'
                >
                  Alfabética (Z-A)
                </a>
              </div>
              <div className='row mx-0 mb-1'>
                <a
                  className='txt-body-sm'
                  value='HIGHERDISCOUNTS'
                  onClick={orderChangeHigherdiscounts}
                  role='button'
                  style={orderColor('HIGHERDISCOUNTS')}
                  tabIndex='0'
                >
                  Maior desconto
                </a>
              </div>
            </div>
          </AccordionItemBody>
        </AccordionItem>
        <AccordionItem
          expanded
          className='filter-accordion filtered-accordion border-color-ui-3 col-12 px-0'
        >
          <AccordionItemTitle className='filter-accordion border-color-ui-3 col-12 px-0'>
            <button className='btn-accordion txt-left border-color-ui-3 txt-body-sm'>
              PERFIL
              <Icon iconName='icon_down' />
            </button>
          </AccordionItemTitle>
          <AccordionItemBody className='panel-accordion border-top border-color-ui-3 bg-white px-2 py-2'>
            <div className='panel-scroll'>
              {profiles &&
                profiles.map((item, index) => {
                  return (
                    <Checkbox
                      key={`profile_${index}`}
                      id={`profile_${item.name}`}
                      value={item.name}
                      className='col-12 form-field-custom px-0'
                      label={`${
                        item.name.trim().length > 17
                          ? item.name.trim().substr(0, 17) + '...'
                          : item.name.trim()
                      } (${item.quantity})`}
                      title={`${item.name} (${item.quantity})`}
                      checked={checkSelected(item.name, 'PROFILE')}
                      onChange={onFilterChange('PROFILE')}
                    />
                  )
                })}
            </div>
          </AccordionItemBody>
        </AccordionItem>

        <AccordionItem
          expanded
          className='filter-accordion filtered-accordion border-color-ui-3 col-12 px-0'
        >
          <AccordionItemTitle className='filter-accordion border-color-ui-3 col-12 px-0'>
            <button className='btn-accordion txt-left border-color-ui-3 txt-body-sm'>
              CATEGORIA
              <Icon iconName='icon_down' />
            </button>
          </AccordionItemTitle>
          <AccordionItemBody className='panel-accordion border-top border-color-ui-3 bg-white px-2 py-2'>
            <div className='panel-scroll'>
              {categories &&
                categories.map((item, index) => {
                  return (
                    <Checkbox
                      key={`category_${index}`}
                      id={`category_${item.name}`}
                      value={item.name}
                      className='col-12 form-field-custom px-0'
                      label={`${
                        item.name.trim().length > 17
                          ? item.name.trim().substr(0, 17) + '...'
                          : item.name.trim()
                      } (${item.quantity})`}
                      title={`${item.name} (${item.quantity})`}
                      checked={checkSelected(item.name, 'CATEGORY')}
                      onChange={onFilterChange('CATEGORY')}
                    />
                  )
                })}
            </div>
          </AccordionItemBody>
        </AccordionItem>
        <AccordionItem
          expanded
          className='filter-accordion filtered-accordion border-color-ui-3 col-12 px-0 d-none'
        >
          <AccordionItemTitle className='filter-accordion border-color-ui-3 col-12 px-0'>
            <button className='btn-accordion txt-left border-color-ui-3 txt-body-sm'>
              LOCALIDADE
              <Icon iconName='icon_down' />
            </button>
          </AccordionItemTitle>
          <AccordionItemBody className='panel-accordion border-top border-color-ui-3 bg-white px-2 py-2'>
            <div className='panel-scroll'>
              {places &&
                places.map((item, index) => {
                  return (
                    <Checkbox
                      key={`place_${index}`}
                      id={`place_${item.name}`}
                      value={item.name}
                      className='col-12 form-field-custom px-0'
                      label={`${
                        item.name.trim().length > 17
                          ? item.name.trim().substr(0, 17) + '...'
                          : item.name.trim()
                      } (${item.quantity})`}
                      title={`${item.name} (${item.quantity})`}
                      checked={checkSelected(item.name, 'PLACE')}
                      onChange={onFilterChange('PLACE')}
                    />
                  )
                })}
            </div>
          </AccordionItemBody>
        </AccordionItem>
        <AccordionItem
          expanded
          className='filter-accordion filtered-accordion border-color-ui-3 col-12 px-0'
        >
          <AccordionItemTitle className='filter-accordion border-color-ui-3 col-12 px-0'>
            <button className='btn-accordion txt-left border-color-ui-3 txt-body-sm'>
              PARCEIRO
              <Icon iconName='icon_down' />
            </button>
          </AccordionItemTitle>
          <AccordionItemBody className='panel-accordion border-top border-color-ui-3 bg-white px-2 py-2'>
            <div className='panel-scroll'>
              {partners &&
                partners.map((item, index) => {
                  return (
                    <Checkbox
                      key={`vendor_${index}`}
                      id={`vendor_${item.name}`}
                      value={item.name}
                      className='col-12 form-field-custom px-0'
                      label={`${
                        item.name.trim().length > 17
                          ? item.name.trim().substr(0, 17) + '...'
                          : item.name.trim()
                      } (${item.quantity})`}
                      title={`${item.name} (${item.quantity})`}
                      checked={checkSelected(item.name, 'PARTNER')}
                      onChange={onFilterChange('PARTNER')}
                    />
                  )
                })}
            </div>
          </AccordionItemBody>
        </AccordionItem>
      </Accordion>
    </Fragment>
  )
}

const filterType = PropTypes.shape({
  order: PropTypes.shape({
    selected: PropTypes.string
  }),
  disabled: PropTypes.string.isRequired
})

Filter.propTypes = {
  profiles: PropTypes.array,
  categories: PropTypes.array,
  places: PropTypes.array,
  partners: PropTypes.array,
  filters: filterType.isRequired,
  onOrderChange: PropTypes.func.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  removeTags: PropTypes.func.isRequired,
  removeAllTags: PropTypes.func.isRequired,
  tags: PropTypes.array
}

export default Filter



// WEBPACK FOOTER //
// ./src/features/Benefits/Filter/Filter.js